"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const constants_1 = require("@/constants");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Styles = {
    datePicker: (error) => core_1.css `
    background: url(${constants_1.Images.calendar}) no-repeat scroll calc(100% - 16px) 12px;
    background-size: ${styles_scss_1.default.l};
    ${error ? `border-color: ${styles_scss_1.default.errorColor};` : ''};
    &:focus {
        background: url(${constants_1.Images.calendarActive}) no-repeat scroll calc(100% - 16px) 12px;
        background-size: ${styles_scss_1.default.l};
    }
  `,
};
exports.default = Styles;
